'use client';
import { useState, useCallback } from 'react';

export interface ConfirmOptions {
	title: string;
	message: string;
	confirmText?: string;
	cancelText?: string;
	variant?: 'danger' | 'warning' | 'info';
}

export const useConfirmModal = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [options, setOptions] = useState<ConfirmOptions>({
		title: '',
		message: '',
		confirmText: 'Confirmar',
		cancelText: 'Cancelar',
		variant: 'danger',
	});
	const [resolvePromise, setResolvePromise] = useState<((value: boolean) => void) | null>(null);

	const confirm = useCallback((confirmOptions: ConfirmOptions): Promise<boolean> => {
		setOptions({
			confirmText: 'Confirmar',
			cancelText: 'Cancelar',
			variant: 'danger',
			...confirmOptions,
		});
		setIsOpen(true);

		return new Promise<boolean>((resolve) => {
			setResolvePromise(() => resolve);
		});
	}, []);

	const handleConfirm = useCallback(() => {
		if (resolvePromise) {
			resolvePromise(true);
		}
		setIsOpen(false);
		setResolvePromise(null);
	}, [resolvePromise]);

	const handleCancel = useCallback(() => {
		if (resolvePromise) {
			resolvePromise(false);
		}
		setIsOpen(false);
		setResolvePromise(null);
	}, [resolvePromise]);

	return {
		confirm,
		isOpen,
		options,
		handleConfirm,
		handleCancel,
	};
};
